export default __webpack_public_path__ + "static/Digital-IDA-Branded-Tearsheet-17f0d09284882035082e11f5021bc954.jpg";